import { Injectable } from '@angular/core'
import { GbApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-api.service'
import { TutorialVideosEntity } from 'gb-dashboard/staff/data-access-tutorial-videos'

@Injectable({
  providedIn: 'root',
})
export class TutorialVideosApiService extends GbApiService {
  getTutorialVideos() {
    const url = `help/tutorial-videos/`
    return this.get<TutorialVideosEntity[]>(url)
  }

  createTutorialVideo(tutorialVideo: Partial<TutorialVideosEntity>) {
    const url = `help/tutorial-videos/`
    return this.post<TutorialVideosEntity>(url, tutorialVideo)
  }

  updateTutorialVideo(tutorialVideo: Partial<TutorialVideosEntity>) {
    const url = `help/tutorial-videos/${tutorialVideo.uuid}/`
    return this.patch<TutorialVideosEntity>(url, tutorialVideo)
  }

  deleteTutorialVideo(uuid: string) {
    const url = `help/tutorial-videos/${uuid}/`
    return this.delete<void>(url)
  }
}
